 
import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist';
const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})
// initial state
const state = {
    WX:{},
    token:'',
    dialog: {
        show: false,
        info: 'hey',
        twoButton: false,
        resolveFn: () => { },
        rejectFn: () => { },
    },
};

// getters
const getters = {};

// actions
const actions = {

};

// mutations
const mutations ={
    set_wx: (state, WX) => {
        state.WX = WX;

    },
    set_token: (state, token) => {
        state.token = token
    },
    set_dialog: (state, payload) => {
        state.dialog = payload
    },
    switch_dialog: (state, payload) => {
        state.dialog.show = payload;
    },
};

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
         
    },
    state,
    getters,
    mutations,
    actions,
    plugins: [vuexLocal.plugin],
    strict: process.env.NODE_ENV !== 'production'
});